import React from 'react'

import { FiAward, FiAlertTriangle, FiUsers, FiBriefcase, FiFileText, FiDownload } from 'react-icons/fi'

function Counters({ counters }) {
    // Extract documents dynamically from counters object
    const documents = Object.keys(counters)
        .filter(key => key.startsWith('documento'))
        .map(key => counters[key])
        .filter(doc => doc && doc.nome && doc.url);

    return (
        <>
            <div className='container-fluid' style={{ marginTop: -126 }}>
                <div className="row">
                    {/* Render documents dynamically */}
                    {documents.map((document, index) => (
                        <div key={index} className="col-xl-3 col-md-6">
                            <div className="card card-stats card-ajust-bottom">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h5 className="card-title text-uppercase text-muted mb-0">Documento</h5>
                                            <span className="h2 font-weight-bold mb-0">
                                                <a href={document.url} target="_blank" rel="noopener noreferrer">
                                                    {document.nome}
                                                </a>
                                            </span>
                                        </div>
                                        <div className="col-auto">
                                            <div className={`icon icon-shape bg-gradient-info text-white rounded-circle shadow ${index === 0 ? 'bg-atrasados' : 'bg-pendente'}`}>
                                                <FiDownload />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    
                    {/* Birthday card - always last */}
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-stats card-ajust-bottom">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col">
                                        <h5 className="card-title text-uppercase text-muted mb-0">Aniversáriantes</h5>
                                        <span className="h2 font-weight-bold mb-0">{counters.aniversarianteTotal}</span>
                                    </div>
                                    <div className="col-auto">
                                        <div className="icon icon-shape bg-gradient-info text-white rounded-circle shadow bg-concluido">
                                            <FiAward />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Counters